import { Product, Subscription } from '@/types/models.types';
import { TrialStatus } from '@/constants/constants';

/**
 * Checks all subscriptions a user has for an author. If the user does not have an active subscription,
 * or has not completed one previously and the product has trial enabled, they are eligible for a trial.
 */
export const getTrialEligibility = (product: Product, subscriptions: Subscription[], authorKey: string): boolean => {
  if (!product) {
    return false;
  }

  const authorSubscriptions = subscriptions.filter((subscription) => subscription.author.id === authorKey);

  const activeSubscription = authorSubscriptions.find((subscription) => subscription.active === true);
  if (activeSubscription) return false;

  if (!product.trialEnabled) return false;

  const previousTrials = authorSubscriptions.filter((subscription) => subscription.trialStatus === 'completed');
  if (previousTrials.length > 0) return false;

  return true;
};

/**
 * Check if the user has already completed a trial for a given product and author
 */
export const hasUserCompletedTrial = (subscriptions: Subscription[], authorId: number): boolean => {
  return subscriptions.some((sub) => sub.author.lookupKey === authorId && sub.trialStatus === TrialStatus.Completed);
};
